import { ORDER_CHANGE_CURRENTPAGE, ORDER_CHANGE_MODE, ORDER_ERROR, ORDER_RECEIVE, ORDER_SET_LIST, ORDER_SET_LOADING_STATUS, ORDER_SET_ORDER, ORDER_SET_REORDER_RESPONSE, ViewMode, } from '../constants';
import { error as errorReducer } from './Error.reducer';
const defaultState = {
    mode: ViewMode.List,
    list: [],
    order: {},
    totalCount: 0,
    showOnlyMyOrders: false,
    errors: {},
    isLoadingList: true,
    isLoadingDetails: true,
    reOrderResponse: null
};
export const order = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case ORDER_RECEIVE:
        case ORDER_CHANGE_MODE:
        case ORDER_CHANGE_CURRENTPAGE:
        case ORDER_SET_ORDER:
        case ORDER_SET_LIST:
        case ORDER_SET_LOADING_STATUS:
        case ORDER_SET_REORDER_RESPONSE:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case ORDER_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
